const $ = jQuery.noConflict();
import { gsap } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger'; 
import './_actual.js'; 
import Swiper from 'swiper/bundle';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
var pad = 0;
function setCSS(){
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
	pad = window.innerWidth * 0.04;
	if(pad < 40){
		pad = 40;
	}
	document.documentElement.style.setProperty('--pad', pad + 'px');

}
let $scrolled = 0;
let $win = $(window);
let $winH = $win.height();
let $caro = 0;
let $sidebarScroll = false;
const menuEl = document.querySelector('#menu');
setCSS();

document.addEventListener('DOMContentLoaded', () => {

	//Approach section animated tab logic
	const tabs = document.querySelectorAll('#approach-tabs .word');
	const contents = document.querySelectorAll('#approach-content .content');
	const wordWrap = document.querySelector('.word-wrap');

	tabs.forEach(tab => {
		tab.addEventListener('click', function() {
			const id = this.getAttribute('data-id'); 
			const isActive = this.classList.contains('active');
			tabs.forEach(t => t.classList.remove('active'));
			contents.forEach(c => c.classList.add('hidden'));
			document.querySelector("#approach-prompt-icon").classList.add("hide");
			document.querySelector("#approach-prompt-label").classList.add("hide");
			if (isActive) {
				wordWrap.classList.remove('init');
			} else {
				this.classList.add('active');
				const correspondingContent = document.querySelector(`#approach-content .content[data-id="${id}"]`);
				correspondingContent.classList.remove('hidden');
				wordWrap.classList.add('init');
			}
		});
	});
	const backButtons = document.querySelectorAll('.approach-back');

	backButtons.forEach(button => {
		button.addEventListener('click', () => {
			contents.forEach(content => {
				content.classList.add('hidden');
			});
			tabs.forEach(tab => {
				tab.classList.remove('active');
			});
			wordWrap.classList.remove('init');
		});
	});

	var handTL = gsap.timeline({repeat: -1,  repeatDelay: .5});
	handTL.to("#icon-hand", {y: -8, duration: 1});
	handTL.to("#icon-hand", {y: 0, duration: 1});
	
	
	var clickTL = gsap.timeline({repeat: -1,  repeatDelay: .5});
	clickTL.to("#icon-click", {opacity: 0, duration: .9});
	clickTL.to("#icon-click", {opacity: 1, duration: .1});
	clickTL.to("#icon-click", {opacity: 0, duration: .1});
	clickTL.to("#icon-click", {opacity: 0, duration: .9});

	
	// swiper instance for quotes
	const swiper = new Swiper('.swiper', {
	  loop: true,
	  
	  speed: 1000,
	  navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	  }
	});
	
	// jump link scrolling logic
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
	
			const href = this.getAttribute('href');
			let yOffset = 0;
			let duration = 1;
	
			if (href === '#scroll') {
				const currentScroll = window.pageYOffset;
				const windowHeight = window.innerHeight;
				yOffset = currentScroll + windowHeight;
			} else  if (href === '#top') {
			   
				yOffset = 0;
			} else if (href.length > 1) {
				const targetElement = document.querySelector(href);
				if (targetElement) {
					yOffset = getPinSpacerPosition(targetElement) || targetElement.offsetTop;
				}
			}
	
			const scrollDistance = Math.abs(yOffset - window.pageYOffset);
			duration = calculateDuration(scrollDistance);
	
			gsap.to(window, {
				scrollTo: { y: yOffset, autoKill: false },
				duration: duration
			});
			
		});
	});

	// scroll logic for intro animation
			
	var headerHeight = document.getElementById('header').offsetHeight;
	gsap.set("#background-loop", { y: headerHeight });

	
	
	const tl1a = gsap.timeline({
	  scrollTrigger: {
		trigger: "#intro",
		pin: true,
		start: "top top",
		end: "bottom top",
		scrub: 1.5,
	  },
	});
	
	tl1a.to("#background-loop", {
	  y: 0,
	  scale: 1.5,
	});
	
	const tl1b = gsap.timeline({
	  scrollTrigger: {
		trigger: "#introduction",
		pin: false,
		start: "top top",
		end: "bottom 50%",
		scrub: 1,
		onEnter: () => {
		},
		onLeaveBack: () => {
		},
	  },
	});
	tl1b.to("#background-veil", {opacity: 1});
	
	gsap.from("#approach", {
	  scrollTrigger: {
		start: "top 75%",
		end: "bottom top",
		trigger: "#approach",
		onEnter: () => {
			  document.querySelector("#approach").classList.add("enable");
			document.querySelector("#menu").classList.add("enable");
		},
		onEnterBack: () => {
			document.querySelector("#approach").classList.add("enable");
		},
		onLeaveBack: () => {
			document.querySelector("#menu").classList.remove("open");
			document.querySelector("#menu").classList.remove("enable");
			document.querySelector("#approach").classList.remove("enable");
		},
	  },
	});
	
	// stroke logo on scroll
	const tlsvg = gsap.timeline({
	  scrollTrigger: {
		trigger: "#introduction",
		pin: false,
		start: "top top",
		end: "bottom center",
		scrub: 1,
		onEnter: () => {
		  document.querySelector("#introduction").classList.add("enable");
		  document.querySelector("#background-loop").classList.add("enable");
		},
		onEnterBack: () => {
		  document.querySelector("#introduction").classList.add("enable");
		  
		  document.querySelector("#background-loop").classList.add("enable");
		},
		onLeaveBack: () => {
		  document.querySelector("#introduction").classList.remove("enable");
		  
		  document.querySelector("#background-loop").classList.remove("enable");
		},
		//ease: 'linear',
	  },
	});
	const tlsvg2 = gsap.timeline({
	  scrollTrigger: {
		trigger: "#introduction",
		pin: false,
		start: "top top",
		end: "bottom -100%",
		scrub: 4,
	  },
	});
	const tlsvg3 = gsap.timeline({
	  scrollTrigger: {
		trigger: "#introduction",
		pin: false,
		start: "top top",
		end: "bottom -50%",
		scrub: 2,
	  },
	});
	
	const path4Animation = preparePathAnimation("#path4");
	tlsvg.fromTo("#path4", path4Animation, { 'stroke-dashoffset': 0, ease: "power2.inOut"  });
	
	const path1Animation = preparePathAnimation("#path1");
	tlsvg2.fromTo("#path1", path1Animation, { 'stroke-dashoffset': 0, ease: "power2.inOut"  });
	
	const path2Animation = preparePathAnimation("#path2");
	tlsvg3.fromTo("#path2", path2Animation, { 'stroke-dashoffset': 0, ease: "power2.inOut"  });
	
	const path3Animation = preparePathAnimation("#path3");
	tlsvg.fromTo("#path3", path3Animation, { 'stroke-dashoffset': 0, ease: "power2.inOut"  });
	
	function preparePathAnimation(selector) {
		const path = document.querySelector(selector);
		const length = path.getTotalLength();
	
		path.style.strokeDasharray = length;
		path.style.strokeDashoffset = length;
	
		return {
			'stroke-dashoffset': length,
			immediateRender: false,
			ease: "none",
		};
	}
	
	// horizontal scroll section
	const horizGallery = document.querySelector("#areas-list");
	
	if (horizGallery) {
	  const getScrollAmount = () => {
		let horizGalleryWidth = horizGallery.scrollWidth;
		return -(horizGalleryWidth - window.innerWidth);
	  };
	
	  const tween = gsap.to(horizGallery, {
		x: getScrollAmount,
		duration: 3,
		ease: "none",
	  });
	
	  ScrollTrigger.create({
		trigger: "#practice-areas",
		start: "top 0",
		end: () => `+=${getScrollAmount() * -1}`,
		pin: true,
		animation: tween,
		scrub: 1,
		invalidateOnRefresh: true,
		markers: false,
	  });
	}
	
	//sticky text on team section
	const teamContainer = document.getElementById('team');
	const stickies = document.querySelectorAll('.team-sticky');
	const containerTop = teamContainer.offsetTop;
	const containerHeight = teamContainer.offsetHeight;
	
	stickies.forEach(sticky => {
	  const stickyHeight = sticky.offsetHeight;
	
	  ScrollTrigger.create({
		trigger: teamContainer,
		start: "top top",
		end: () => `+=${containerHeight - stickyHeight}`,
		onEnter: () => setSticky(sticky, 'fixed', 0),
		onLeave: () => setSticky(sticky, 'absolute', containerHeight - stickyHeight),
		onEnterBack: () => setSticky(sticky, 'fixed', 0),
		onLeaveBack: () => setSticky(sticky, 'absolute', 0)
	  });
	});
	
	// team overlays
	function setupOverlay(el){
		var headshot = el.querySelector('figure img').cloneNode(true);
		var details = el.querySelector('.name').cloneNode(true);
		var bio = el.querySelector('.team-card-bio').cloneNode(true);
		document.querySelector('.team-bio-overlay .bio-overlay-photo figure').innerHTML = '';
		document.querySelector('.team-bio-overlay .bio-overlay-photo figure').appendChild(headshot);
		document.querySelector('.team-bio-overlay .bio-overlay-content').innerHTML = bio.innerHTML;
		document.querySelector('.team-bio-overlay .bio-overlay-details').innerHTML = details.innerHTML;
		document.querySelector('.team-bio-overlay').classList.add('shown');
	}
	document.querySelectorAll('.team-card').forEach(function(card) {
		card.addEventListener('click', function(e) {
			setupOverlay(this);
			e.stopPropagation();
			e.preventDefault();
		});
	});
	
	document.querySelector('.team-bio-overlay .bio-overlay-veil').addEventListener('click', function(e) {
		document.querySelector('.team-bio-overlay').classList.remove('shown');
		e.stopPropagation();
		e.preventDefault();
	});
	document.querySelector('.team-bio-overlay .toggle-overlay').addEventListener('click', function(e) {
		document.querySelector('.team-bio-overlay').classList.remove('shown');
		e.stopPropagation();
		e.preventDefault();
	});

	
	// clients background paralax
	var clientsContent = document.querySelector("#clients");
	var clientsBackground = document.querySelector("#clients-background");
	if(clientsBackground){
		gsap.to(clientsBackground, {
			y: clientsBackground.offsetHeight - (clientsContent.offsetHeight*1.25),
			ease: "none",
			scrollTrigger: {
				trigger: clientsContent,
				// markers: true,
				scrub: true
			}
		});
	}

	const menuToggleElements = document.querySelectorAll('.toggle-menu');
	
	menuToggleElements.forEach(function(element) {
		element.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			if (!menuEl.classList.contains('open')) {
				menuEl.classList.add('open');
			} else {
				menuEl.classList.remove('open');
			}
		});
	});
	menuEl.addEventListener('click', function(e) {
		if (e.target.closest('a')) {
			return; 
		}
		e.preventDefault();
		e.stopPropagation();
		
		if (!menuEl.classList.contains('open') && menuEl.classList.contains('enable') ) {
			menuEl.classList.add('open');
		} 
	});
	const menuLinks = document.querySelectorAll('#menu a');
	menuLinks.forEach(function(element) {
		element.addEventListener('click', function(e) {
			//e.preventDefault();
			//e.stopPropagation();
			menuEl.classList.remove('open');
		});
	});


	
});
function isVisible(el) {
	return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}
function calculateDuration(distance) {
	const baseDuration = 1;
	const speed = 0.15; 
	return baseDuration + (distance * speed) / 1000;
}
function getPinSpacerPosition(element) {
	let parent = element.parentNode;
	while (parent) {
		if (parent.classList && parent.classList.contains('pin-spacer')) {
			return parent.offsetTop;
		}
		parent = parent.parentNode;
	}
	return null;
}
function setSticky(element, position, top) {
  element.style.position = position;
  element.style.top = top + 'px';
}

function setStage(){
	setCSS();

	const words = document.querySelectorAll('.word');
	words.forEach(word => {
		const h3 = word.querySelector('h3');
		h3.style.visibility = 'hidden'; 
		h3.style.position = 'absolute';
		h3.style.display = 'block';
		const width = h3.offsetWidth;
		word.style.setProperty('--max', `${width}px`);
		h3.style.visibility = '';
		h3.style.position = '';
	});
	const content = document.querySelectorAll('#approach-content .content');
	
	content.forEach(content => {
		const container = content.querySelector('.container'); 
		if (container) {
			content.style.visibility = 'hidden'; 
			content.style.position = 'absolute';
			content.style.display = 'block';
			const height = container.offsetHeight;
			content.style.setProperty('--max-height', `${height}px`);
			content.style.visibility = '';
			content.style.position = '';
		}
	});
	
	var headerHeight = document.getElementById('header').offsetHeight;
	gsap.set("#background-loop", { y: headerHeight });

}
document.addEventListener("DOMContentLoaded", function() {
  document.body.classList.add("loaded");
});
function debounce(func, wait) {
	let timeout;
	return function() {
		const context = this, args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}
const debouncedResize = debounce(setStage, 250); 
window.addEventListener('resize', debouncedResize);
window.addEventListener('load', setStage);